import { useMount } from 'shared/src/hooks';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogViewIntroSignUp = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  useMount(() => {
    logAnalyticsEvent({
      name: 'VIEW_INTRO_SIGN_UP',
      channel: ['firebase', 'amplitude', 'ablylog'],
    });
  });
};
